import { AllChargeTypes, AllBranchSettingKeys, AllGroupTypes } from "./Queries"

const ObjectPermissionsConfigurations = {
    chargetype: { query: AllChargeTypes },
    branchsettingkey: { query: AllBranchSettingKeys },
    grouptype: { query: AllGroupTypes },
}


export default ObjectPermissionsConfigurations